import {
  Edit,
  FormTab,
  TabbedForm,
  TextInput,
  BooleanInput,
  required,
  ArrayInput,
  SimpleFormIterator,
  SelectInput,
  ReferenceInput,
  useGetIdentity,
  TopToolbar,
  ListButton,
} from 'react-admin'
import * as React from 'react'
import * as PropTypes from 'prop-types'

const CampaignsEditActions = ({ identity, basePath }) => {
  let countryBasePath = ''
  if (identity.role !== 'admin') {
    countryBasePath = `${basePath}?filter={"country":"${identity.country}"}`
  }
  return (
    <TopToolbar>
      <ListButton basePath={countryBasePath} />
    </TopToolbar>
  )
}

CampaignsEditActions.propTypes = {
  basePath: PropTypes.any,
  identity: PropTypes.any,
}

export const CampaignsEdit = props => {
  const { identity, loading: identityLoading } = useGetIdentity()
  if (identityLoading) return <>Loading...</>
  const country = identity.country
  const questionSource = 'label.' + country.toLowerCase()

  return (
    <Edit actions={<CampaignsEditActions identity={identity} />} {...props}>
      <TabbedForm submitOnEnter={false} syncWithLocation={false}>
        <FormTab label="Summary">
          <TextInput source="name" validate={required()} />
          <TextInput source="country" defaultValue={country} disabled />
          <BooleanInput source="status" />
        </FormTab>
        <FormTab label="Questions">
          <ArrayInput source="questionIds">
            <SimpleFormIterator>
              <ReferenceInput
                translateChoice={false}
                label="Question"
                source=""
                reference="questions"
                filter={{ country: identity.country, next_question_id: null }}
              >
                <SelectInput optionText={questionSource} />
              </ReferenceInput>
            </SimpleFormIterator>
          </ArrayInput>
        </FormTab>
      </TabbedForm>
    </Edit>
  )
}
